const axios = require("axios");
import store from "../store/index";
const BASE_URL = process.env.VUE_APP_BASE_URL;
const MODE = process.env.VUE_APP_PROJECT_MODE;

function setSessionParticipantsReviews(req = {}) {
  return axios({
    method: "post",
    url: getCompleteURL(`-v2-${MODE}-set-session-participants-reviews`),
    data: req,
    headers: {
      Authorization: `Bearer ${getToken()}`
    }
  });
}
function getPostSessions(req = {}) {
  return axios({
    method: "post",
    url: getCompleteURL(`-v2-${MODE}-statistics-generator-post-sessions-api`),
    data: req,
    headers: {
      Authorization: `Bearer ${getToken()}`
    }
  });
}
function getPreSessions(req = {}){
  return axios({
    method: "post",
    url: getCompleteURL(`-v2-${MODE}-statistics-generator-api`),
    data: req,
    headers: {
      Authorization: `Bearer ${getToken()}`
    }
  });
}
function getSessionParticipantsReviews(req = {}) {
  return axios({
    method: "post",
    url: getCompleteURL(`-v2-${MODE}-get-session-participants-reviews`),
    data: req,
    headers: {
      Authorization: `Bearer ${getToken()}`
    }
  });
}
function addReview(req = {}) {
  return axios({
    method: "post",
    url: getCompleteURL(`-v2-${MODE}-add-review`),
    data: req,
    headers: {
      Authorization: `Bearer ${getToken()}`
    }
  });
}
function getReviews(req = {}) {
  return axios({
    method: "post",
    url: getCompleteURL(`-v2-${MODE}-get-reviews`),
    data: req,
    headers: {
      Authorization: `Bearer ${getToken()}`
    }
  });
}
function getAuthToken(req = {}) {
  return axios({
    method: "post",
    url: getCompleteURL("-prd-get-auth-token"),
    data: {
      emailId: req.emailId,
      password: req.password
    }
  });
}
function sendMessage(req) {
  return axios({
    method: "post",
    url: getCompleteURL(`-v2-${MODE}-send-sms`),
    data: req,
    headers: {
      Authorization: `Bearer ${getToken()}`
    }
  });
}
function deleteAssignment(req = {}) {
  return axios({
    method: "post",
    url: getCompleteURL(`-v2-${MODE}-delete-assignment`),
    data: req,
    headers: {
      Authorization: `Bearer ${getToken()}`
    }
  });
}
function getClientConfig(req = {}) {
  return axios({
    method: "post",
    url: getCompleteURL(`-v2-${MODE}-get-client-config`),
    data: {
      clientId: req.clientId
    },
    headers: {
      Authorization: `Bearer ${getToken()}`
    }
  });
}
function sendMail(req = {}) {
  return axios({
    method: "post",
    url: getCompleteURL(`-v2-${MODE}-send-mail`),
    data: req,
    headers: {
      Authorization: `Bearer ${getToken()}`
    }
  });
}
function getSessionDetails(req = {}) {
  return axios({
    method: "post",
    url: getCompleteURL(`-v2-${MODE}-get-session-details`),
    data: {
      key: {
        instanceId: req.instanceId,
        clientId: req.clientId,
        eventId: req.eventId,
        sessionId: req.sessionId
      }
    },
    headers: {
      Authorization: `Bearer ${getToken()}`
    }
  });
}

function getEventDetails(req = {}) {
  return axios({
    method: "post",
    url: getCompleteURL(`-v2-${MODE}-get-event-details`),
    data: {
      key: {
        instanceId: req.instanceId,
        clientId: req.clientId,
        eventId: req.eventId
      }
    },
    headers: {
      Authorization: `Bearer ${getToken()}`
    }
  });
}
function getAllSessionsByEvents(req = {}) {
  return axios({
    method: "post",
    url: getCompleteURL(`-v2-${MODE}-get-all-sessions-by-events`),
    data: {
      key: {
        instanceId: req.instanceId,
        clientId: req.clientId,
        attendeeId: req.attendeeId,
        eventId: req.eventId,
        isClient: req.isClient ? true : false
      },
      data: { startDate: req.startDate }
    },
    headers: {
      Authorization: `Bearer ${getToken()}`
    }
  });
}
function getCourseDetailsByEvents(req = {}) {
  return axios({
    method: "post",
    url: getCompleteURL(`-v2-${MODE}-get-event-details`),
    data: {
      key: {
        instanceId: req.instanceId,
        clientId: req.clientId,
        eventId: req.eventId
      },
      data: []
    },
    headers: {
      Authorization: `Bearer ${getToken()}`
    }
  });
}
function getSelectedCourseDetails(req = {}) {
  let url = "iid=" + req.iid + "&cid=" + req.cid + "&eid=" + req.eid;
  var config = {
    method: "get",
    url:
      "https://us-central1-e2medu.cloudfunctions.net/e2medu-prd-get-course?" +
      url,
    headers: {
      Authorization: `Bearer ${getToken()}`
    },
    data: ""
  };
  return axios(config);
}
function getCoursesByEvents(req = {}) {
  return axios({
    method: "post",
    url: getCompleteURL(`-v2-${MODE}-get-user-events`),
    data: {
      key: {
        instanceId: req.instanceId,
        clientId: req.clientId,
        attendeeId: req.attendeeId
      },
      data: {}
    },
    headers: {
      Authorization: `Bearer ${getToken()}`
    }
  });
}
function getUserComment(req = {}) {
  return axios({
    method: "post",
    url: getCompleteURL(`-v2-${MODE}-get-user-comment`),
    data: {
      teacherId: req.teacherId,
      clientId: req.clientId,
      attendeeId: req.attendeeId,
      assignmentId: req.assignmentId
    },
    headers: {
      Authorization: `Bearer ${getToken()}`
    }
  });
}
function createAssignment(req = {}) {
  return axios({
    method: "post",
    url: getCompleteURL(`-v2-${MODE}-submit-assignment`),
    data: req,
    headers: {
      Authorization: `Bearer ${getToken()}`
    }
  });
}
function addFileToAssignment(req = {}) {
  return axios({
    method: "post",
    url: getCompleteURL(`-v2-${MODE}-add-file-to-assignment`),
    data: req
  });
}
function publishAssignment(req = {}) {
  let body = {
    clientId: req.clientId,
    sessionId: req.sessionId,
    assignmentId: req.assignmentId,
    eventId: req.eventId
  };
  if (req.attendeeList) {
    body.attendeeList = req.attendeeList;
  }
  return axios({
    method: "post",
    url: getCompleteURL(`-v2-${MODE}-publish-assignment`),
    data: body,
    headers: {
      Authorization: `Bearer ${getToken()}`
    }
  });
}
function postUserComment(req = {}) {
  return axios({
    method: "post",
    url: getCompleteURL(`-v2-${MODE}-submit-user-comment`),
    data: req,
    headers: {
      Authorization: `Bearer ${getToken()}`
    }
  });
}
function postUserAssignment(req = {}) {
  return axios({
    method: "post",
    url: getCompleteURL("-v2-uat-submit-user-assignment"),
    data: req,
    headers: {
      Authorization: `Bearer ${getToken()}`
    }
  });
}
function getAllAssignmentsDetails(req = {}) {
  return axios({
    method: "post",
    url: getCompleteURL(`-v2-${MODE}-get-assignment`),
    data: req,
    headers: {
      Authorization: `Bearer ${getToken()}`
    }
  });
}
function getZoomMeetingDetails(req = {}) {
  return axios({
    method: "post",
    url: getCompleteURL(`-v2-${MODE}-get-zoom-meeting-details`),
    data: {
      key: {
        instanceId: req.instanceId,
        clientId: req.clientId,
        eventId: req.eventId,
        topicId: req.topicId
      },
      data: []
    },
    headers: {
      Authorization: `Bearer ${getToken()}`
    }
  });
}
function getCompleteURL(url = "") {
  return BASE_URL + url;
}
function getToken() {
  return getCookie("token");
}
function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
function postAssessUserAssignment(req = {}) {
  return axios({
    method: "post",
    url: getCompleteURL("-v2-uat-assess-assignment"),
    data: req,
    headers: {
      Authorization: `Bearer ${getToken()}`
    }
  });
}
function sendEventAnalytics(req = {}) {
  let path = "";
  if (window.location.href.includes("localhost"))
    path = `https://us-central1-uate2monair.cloudfunctions.net/e2moaanalytics-uat-insert-user-action`;
  if (window.location.href.includes("e2medutest.web.app"))
    path = `https://us-central1-uate2monair.cloudfunctions.net/e2moaanalytics-stg-insert-user-action`;
  if (window.location.href.includes("e2medufirebase.web.app"))
    path = `https://us-central1-uate2monair.cloudfunctions.net/e2moaanalytics-prd-insert-user-action`;
  let user = store.state.user;
  req.origin = "Responsive";
  req.instanceId = "OA_UAT";
  req.clientId = store.state.client[0].id;
  req.userId = user[0].id;
  req.userEmail = user[0].Email;
  req.userName = user[0].name;
  axios({
    method: "post",
    url: path,
    data: req
  })
    .then(() => {})
    .catch(e => {
      console.log(e);
    });
}
axios.interceptors.request.use(
  function(config) {
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

// Add a response interceptor
axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    return Promise.reject(error);
  }
);
export default {
  getAuthToken,
  getSessionDetails,
  getEventDetails,
  getAllSessionsByEvents,
  getAllAssignmentsDetails,
  getCourseDetailsByEvents,
  getZoomMeetingDetails,
  getCoursesByEvents,
  publishAssignment,
  createAssignment,
  getUserComment,
  postUserComment,
  postUserAssignment,
  postAssessUserAssignment,
  sendEventAnalytics,
  getClientConfig,
  sendMail,
  deleteAssignment,
  sendMessage,
  addFileToAssignment,
  addReview,
  getReviews,
  getSelectedCourseDetails,
  setSessionParticipantsReviews,
  getSessionParticipantsReviews,
  getPostSessions,
  getPreSessions
};
